module.exports = __webpack_public_path__ + "img/43800.853091b3.jpg";